"use client";

import { c as _c } from "react/compiler-runtime";
import { Modal } from "@/shared/ui/templates";
import { ReviewFilterModalTabs } from "@/widgets/hospital/ui/organisms";
import { ReviewFilterModalBody } from "@/features/hospital/ui/organisms";
import { TextButton } from "@/shared/ui/atoms";
import { useFeaturesHospitalStore } from "@/features/hospital/model/store";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { useTranslations } from "next-intl";
import { useHospitalOriginId } from "@/entities/hospital/model/hospital-origin-id";
interface ReviewFilterModalProps {
  open: boolean;
  onClose: () => void;
}
const ReviewFilterModal = t0 => {
  const $ = _c(46);
  const {
    open,
    onClose
  } = t0;
  const t = useTranslations();
  const router = useRouter();
  const id = useHospitalOriginId();
  const query = useSearchParams();
  let t1;
  if ($[0] !== query) {
    t1 = query.get("subject") ?? null;
    $[0] = query;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const subject = t1;
  let t2;
  if ($[2] !== query) {
    t2 = query.get("major") ?? null;
    $[2] = query;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const major = t2;
  let t3;
  if ($[4] !== query) {
    t3 = query.get("minor") ?? null;
    $[4] = query;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const minor = t3;
  const {
    selectedSubjectFilter,
    selectedDetailFilter,
    resetReviewFilter,
    setSelectedSubjectFilter,
    setSelectedDetailFilter
  } = useFeaturesHospitalStore();
  let t4;
  if ($[6] !== resetReviewFilter) {
    t4 = () => {
      resetReviewFilter();
    };
    $[6] = resetReviewFilter;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleReset = t4;
  let t5;
  if ($[8] !== id || $[9] !== onClose || $[10] !== router || $[11] !== selectedDetailFilter?.major || $[12] !== selectedDetailFilter?.minor || $[13] !== selectedSubjectFilter) {
    t5 = () => {
      router.push(`/review-detail/${id}?subject=${selectedSubjectFilter}&major=${selectedDetailFilter?.major}&minor=${selectedDetailFilter?.minor}`);
      onClose();
    };
    $[8] = id;
    $[9] = onClose;
    $[10] = router;
    $[11] = selectedDetailFilter?.major;
    $[12] = selectedDetailFilter?.minor;
    $[13] = selectedSubjectFilter;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const handleComplete = t5;
  let t6;
  let t7;
  if ($[15] !== major || $[16] !== minor || $[17] !== open || $[18] !== resetReviewFilter || $[19] !== setSelectedDetailFilter || $[20] !== setSelectedSubjectFilter || $[21] !== subject) {
    t6 = () => {
      if (subject) {
        setSelectedSubjectFilter(subject);
      }
      if (major) {
        setSelectedDetailFilter({
          major: major ?? "",
          minor: minor ?? ""
        });
      }
      if (!open) {
        return resetReviewFilter();
      }
    };
    t7 = [major, minor, subject, setSelectedDetailFilter, setSelectedSubjectFilter, resetReviewFilter, open];
    $[15] = major;
    $[16] = minor;
    $[17] = open;
    $[18] = resetReviewFilter;
    $[19] = setSelectedDetailFilter;
    $[20] = setSelectedSubjectFilter;
    $[21] = subject;
    $[22] = t6;
    $[23] = t7;
  } else {
    t6 = $[22];
    t7 = $[23];
  }
  useEffect(t6, t7);
  let t8;
  if ($[24] !== t) {
    t8 = t("filter.customFilter");
    $[24] = t;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t10;
  let t9;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ReviewFilterModalTabs />;
    t10 = <ReviewFilterModalBody />;
    $[26] = t10;
    $[27] = t9;
  } else {
    t10 = $[26];
    t9 = $[27];
  }
  let t11;
  if ($[28] !== t) {
    t11 = t("filter.reset");
    $[28] = t;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== handleReset || $[31] !== t11) {
    t12 = <TextButton text={t11} className="w-[33%] py-3 bg-white border border-gray-200 text-gray-700 rounded font-medium" onClick={handleReset} />;
    $[30] = handleReset;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t) {
    t13 = t("filter.apply");
    $[33] = t;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== handleComplete || $[36] !== t13) {
    t14 = <TextButton text={t13} className="w-[66%] py-3 bg-primary-600 text-white rounded font-semibold disabled:bg-[#F7F7F7] disabled:text-[#989BA2] disabled:cursor-not-allowed" onClick={handleComplete} />;
    $[35] = handleComplete;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t12 || $[39] !== t14) {
    t15 = <div className="flex gap-[6px] fixed bottom-0 w-full max-w-[600px] mx-auto bg-white py-3 px-4">{t12}{t14}</div>;
    $[38] = t12;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== onClose || $[42] !== open || $[43] !== t15 || $[44] !== t8) {
    t16 = <Modal open={open} onClose={onClose} title={t8} round="16px" height="80%">{t9}{t10}{t15}</Modal>;
    $[41] = onClose;
    $[42] = open;
    $[43] = t15;
    $[44] = t8;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  return t16;
};
export default ReviewFilterModal;